import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { Table, TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService, MessageService } from 'primeng/api';

import { L94Rfil94Service } from '@/core/service/l94_rfil_94.service';
import { L94Rfil94 } from '@/core/models/models/pages/l94rfil94';

@Component({
    selector: 'app-schede-l94',
    standalone: true,
    providers: [ConfirmationService, MessageService],
    imports: [CommonModule, ButtonModule, TableModule, InputTextModule, ToolbarModule, ConfirmDialogModule, ToastModule, TooltipModule],
    templateUrl: './scheda-l94.component.html',
    styleUrl: './scheda-l94.component.scss'
})
export class SchedeL94Component implements OnInit {
    @ViewChild('dt') table?: Table;

    l94Items: L94Rfil94[] = [];

    constructor(
        private l94Service: L94Rfil94Service,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.loadData();
    }

    private loadData(): void {
        this.l94Service.getL94Rfil94Aggregate().subscribe({
            next: (items) => (this.l94Items = items),
            error: (err) => {
                console.error('Errore caricamento L94', err);
                this.showError('Errore nel caricamento dei dati');
            }
        });
    }

    onNuovo(): void {
        this.router.navigate(['/scheda-l94/nuovo']);
    }

    onModifica(item: L94Rfil94): void {
        this.router.navigate(['/scheda-l94', item.id]);
    }

    onVisualizza(item: L94Rfil94): void {
        this.router.navigate(['/scheda-l94', item.id], { queryParams: { mode: 'view' } });
    }

    onElimina(item: L94Rfil94): void {
        this.confirmationService.confirm({
            message: `Sei sicuro di voler eliminare "${item.dettaglio}"?`,
            header: 'Conferma eliminazione',
            icon: 'pi pi-exclamation-triangle',
            acceptButtonStyleClass: 'p-button-danger',
            acceptIcon: 'pi pi-trash',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => this.deleteItem(item)
        });
    }

    private deleteItem(item: L94Rfil94): void {
        if (!item.id) return;
        this.l94Service.delete(item.id).subscribe({
            next: () => {
                this.showSuccess('Elemento eliminato con successo');
                this.loadData();
            },
            error: (err) => {
                console.error('Errore eliminazione', err);
                this.showError("Errore durante l'eliminazione");
            }
        });
    }

    private showSuccess(detail: string): void {
        this.messageService.add({ severity: 'success', summary: 'Operazione completata', detail });
    }
    private showError(detail: string): void {
        this.messageService.add({ severity: 'error', summary: 'Errore', detail });
    }
}
